import { render, staticRenderFns } from "./customer_tag.vue?vue&type=template&id=2fa9a26e&scoped=true"
import script from "./customer_tag.vue?vue&type=script&lang=ts"
export * from "./customer_tag.vue?vue&type=script&lang=ts"
import style0 from "./customer_tag.vue?vue&type=style&index=0&id=2fa9a26e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa9a26e",
  null
  
)

export default component.exports